module.exports = __webpack_public_path__ + "img/keyboard_5.c2a060f5.png";